const styles = (theme) => ({
  bannerContainer: {
    width: "100vw",
    backgroundColor: theme.palette.secondary.light,
    display: "flex",
    justifyContent: "center",
  },
  bannerText: {
    padding: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
  link: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0),
    width: "100%",
    justifyContent: "center",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      flexWrap: "wrap",
      padding: theme.spacing(0.75),
      lineHeight: 1.4,
    },
  },
  arrow: {
    marginLeft: theme.spacing(1),
    fontSize: "2rem",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      marginLeft: theme.spacing(0.5),
    },
  },
  button: {
    marginLeft: theme.spacing(2),
    textTransform: "none",
    // fontWeight: "bold",
  },
});
export default styles;
